import { onNavClick } from '../lib/router';
import '../styles/owner-web-conversation.css';

/** Human navigation only: no session, message, microphone or preference is created. */
export function OwnerConversationAccess() {
  return <aside className="owner-conversation-access" aria-label="Seu canal com o orquestrador"><div><span>CONVERSA DONIZETI</span><h2>Fale com o seu orquestrador</h2><p>A mesma conversa do app. Escreva, grave um áudio ou leia as respostas por aqui.</p></div><a aria-label="Donizeti · Orquestrador — Abrir conversa" href="/donizeti" onClick={onNavClick('/donizeti')}>Abrir conversa <span aria-hidden="true">↗</span></a></aside>;
}
